import styled, {css} from 'styled-components'

export const StyledTabsWrapper = styled.div`
    ${({theme: {spacing}}) => css`
        margin-top: ${spacing * 8}px;
    `}
`
